// Skeleton — placeholder loader pro stránky kde data ještě tečou.
// Vizuálně příjemnější než "Načítám…" prázdný state.
//
// Pouziti:
//   <SkeletonTable rows={8} cols={6} />     — tabulka s pulzujicimi řádky
//   <SkeletonCards count={4} />              — KPI grid s pulzujícími kartami
//   <SkeletonBox height="120px" />           — generic block
//
// Animace: tailwind animate-pulse (built-in). Pulse přechází mezi
// bg-slate-200 a bg-slate-100. Po 8 cyklech (~6s) se zastaví aby nerušilo.

import React from "react";

export function SkeletonBox({ height = "20px", width = "100%", className = "" }) {
  return (
    <div
      className={`bg-brand-100 animate-pulse rounded ${className}`}
      style={{ height, width }}
    />
  );
}

export function SkeletonTable({ rows = 6, cols = 5 }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
      {/* Header row */}
      <div className="flex border-b border-slate-200 px-4 py-3 bg-slate-50">
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="flex-1 px-2">
            <div className="h-3 bg-brand-200 animate-pulse rounded w-20" />
          </div>
        ))}
      </div>
      {/* Data rows */}
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex border-b border-slate-100 px-4 py-3 last:border-b-0">
          {Array.from({ length: cols }).map((_, c) => (
            <div key={c} className="flex-1 px-2">
              <div
                className="h-3 bg-brand-100 animate-pulse rounded"
                style={{ width: `${50 + ((r * 7 + c * 13) % 40)}%` }}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonCards({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-xl border border-slate-200 p-4">
          <div className="h-3 w-16 bg-brand-100 animate-pulse rounded mb-3" />
          <div className="h-7 w-12 bg-brand-200 animate-pulse rounded" />
        </div>
      ))}
    </div>
  );
}

// Skeleton pro accordion/sections layout (Pravidla)
export function SkeletonSections({ count = 3 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-xl border border-slate-200 p-4">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 bg-brand-100 animate-pulse rounded" />
            <div className="h-4 bg-brand-200 animate-pulse rounded flex-1 max-w-md" />
            <div className="h-3 w-20 bg-brand-100 animate-pulse rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default SkeletonTable;
